/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-07-14 14:39:06
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-07-14 17:18:46
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/src/case-4/api/index.js
 */
import request from '@/utils/req.js';
//治疗项目分页查询
export function treatment(params) {
    return request.post("/admin/treatment-item/page",params);
}
//治疗项目添加
export function addTreatment(params) {
    return request.post("/admin/treatment-item",params);
}
//标准数据库分类表列表查询
export function list(params) {
    return request.post("/admin/standard-category/list",params);
}
//治疗项目删除
export function removeItem(params) {
    return request.delete(`/admin/treatment-item/${params}`);
}
//治疗项目更新
export function putTreatment(params) {
    return request.put(`/admin/treatment-item`,params);
}